export class EndpointIcon {
    constructor(style) {
        this.renderer = {
            circle: this.circle,
            square: this.square,
            triangle: this.triangle,
        };
        this.canvas = document.createElement("canvas");
        this.style = style;
        this.setStyle(style);
    }
    setStyle(style) {
        this.style = style;
        this.canvas.width = style.size * 2;
        this.canvas.height = style.size * 2;
        this._render();
    }
    _render() {
        const renderer = this.style.style || "circle";
        console.log("rendering", this.style, "using", renderer);
        this.renderer[renderer].bind(this)();
    }
    getContext() {
        let ctx = this.canvas.getContext("2d");
        if (!ctx) {
            throw new Error("Unable to get context");
        }
        return ctx;
    }
    initIcon() {
        let ctx = this.getContext();
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        return ctx;
    }
    circle() {
        let ctx = this.initIcon();
        let style_rule = this.style;
        if (style_rule.colour === "") {
            return;
        }
        let center = style_rule.size;
        ctx.beginPath();
        ctx.arc(center, center, style_rule.size, 0, 2 * Math.PI, true);
        if (style_rule.fill) {
            ctx.fillStyle = style_rule.colour;
            ctx.fill();
        }
        else {
            ctx.strokeStyle = style_rule.colour;
            ctx.lineWidth = style_rule.width || 1.0;
            ctx.stroke();
        }
        ctx.closePath();
    }
    square() {
        let ctx = this.initIcon();
        let style_rule = this.style;
        if (style_rule.colour === "") {
            return;
        }
        let size = style_rule.size * 2;
        if (style_rule.fill) {
            ctx.fillStyle = style_rule.colour;
            ctx.fillRect(0, 0, size, size);
        }
        else {
            ctx.strokeStyle = style_rule.colour;
            ctx.lineWidth = style_rule.width || 1.0;
            ctx.strokeRect(0, 0, size, size);
        }
    }
    triangle() {
        let ctx = this.initIcon();
        let style_rule = this.style;
        if (style_rule.colour === "") {
            return;
        }
        let size = style_rule.size * 2;
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(0.5 * size, size);
        ctx.lineTo(size, 0);
        ctx.lineTo(0, 0);
        ctx.closePath();
        if (style_rule.fill) {
            ctx.fillStyle = style_rule.colour;
            ctx.fill();
        }
        else {
            ctx.strokeStyle = style_rule.colour;
            ctx.lineWidth = style_rule.width || 1.0;
            ctx.stroke();
        }
    }
}
